import { z } from "zod";
import { zString } from "./commonSchemaObjects";

export const switchRoleSchema = z.object({
  roles: zString.zRequired,
});
